import type {
  Gender,
  PersonRoles,
  PersonStanding,
  RegisteredPerson,
} from './contracts';

export const GENDER_LABELS: Record<Gender, string> = {
  female: 'Female',
  male: 'Male',
  'non-binary': 'Non-binary',
};

export const NO_ROLES: PersonRoles = {
  bobaMember: false,
  ftloMember: false,
  currentStaff: false,
};

export function isMember(roles: PersonRoles): boolean {
  return roles.bobaMember || roles.ftloMember;
}

export function isStaff(roles: PersonRoles): boolean {
  return roles.currentStaff;
}

export function personStanding(person: RegisteredPerson): PersonStanding {
  if (isStaff(person.roles)) return 'staff';
  return isMember(person.roles) ? 'member' : 'public';
}
